import React, { useState } from 'react'
import classNames from 'classnames'
import { DigitalData } from '../utils/digital-data'
import { NavigationEventType } from '../utils/digital-data-types'

type Props = {
  open: boolean
  onToggle: (arg0: boolean) => void
  className?: string
}

export const Hamburger = ({ open, onToggle, className = '' }: Props) => {
  const [animate, setAnimate] = useState(false)

  const handleClick = () => {
    onToggle(!open)
    setAnimate(true)
    !open
      ? DigitalData.pushNavigationInteraction(NavigationEventType.MainMenu, 'products', 'open_menu')
      : DigitalData.pushNavigationInteraction(NavigationEventType.MainMenu, 'close', 'close_menu')
  }

  return (
    <button
      className={classNames('c-hamburger', {
        'c-hamburger--animate-to-opened': open && animate, // Animate to opened state
        'c-hamburger--opened': open && !animate, // Static opened state
        'c-hamburger--animate-to-closed': !open && animate, // Animate to closed state
        [`${className}`]: className,
      })}
      onClick={() => handleClick()}
      onAnimationEnd={() => setAnimate(false)}
      data-test-id="mobile-header-menu"
      aria-label="mobile-header-menu">
      <svg className="c-hamburger__icon" viewBox="0 0 32 32">
        <path d="M29.8 7h-27.6c-0.11 0-0.2-0.090-0.2-0.2v-1.6c0-0.11 0.090-0.2 0.2-0.2h27.6c0.11 0 0.2 0.090 0.2 0.2v1.6c0 0.11-0.090 0.2-0.2 0.2z"></path>
        <path d="M29.8 17h-27.6c-0.11 0-0.2-0.090-0.2-0.2v-1.6c0-0.11 0.090-0.2 0.2-0.2h27.6c0.11 0 0.2 0.090 0.2 0.2v1.6c0 0.11-0.090 0.2-0.2 0.2z"></path>
        <path d="M29.8 27h-27.6c-0.11 0-0.2-0.090-0.2-0.2v-1.6c0-0.11 0.090-0.2 0.2-0.2h27.6c0.11 0 0.2 0.090 0.2 0.2v1.6c0 0.11-0.090 0.2-0.2 0.2z"></path>
      </svg>
    </button>
  )
}

export default Hamburger
